import ApiProvider from "../../../lib/providers/ApiProvider";
import { serviceUtil } from "../../commons/utils/services";
import { HeadersMapping } from "../../commons/mappings/headers.mapping";
import { URLConfiguration } from "../../commons/constants/url.configuration";
import CaptchaRequest from "../../commons/mappings/captchaRequest.mapping";

class CaptchaProvider {
    
    constructor() {
        this.paths          = URLConfiguration.paths;
        this.captchaRequest = new CaptchaRequest();
        this.apiProvider    = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH)
    }

    postCaptcha = async (token) => {
        const headers   = HeadersMapping.getHeaderService();
        const request   = this.captchaRequest.postCaptcha(token);
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.simulacionProductosRentas.captcha, { });
        let response    = null;
        try {
            response = await this.apiProvider.post( pathNew, request, { headers } );
        } catch (error) {
            console.log(error);
        }
        return response;
    }

}

export default CaptchaProvider;